module.exports = __webpack_public_path__ + "static/img/2019-01.bae08aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/publication/2019-01.png
// module id = 682P
// module chunks = 6